module.exports = __webpack_public_path__ + "static/comfort-2-1387643db40cd44d22dbabdb0b58aad0.png";